import BigQueryParser from '@acho-inc/js-bigquery-parser';

const defaultConfig = {
  flavor: 'standardsql'
};

const BIGQUERY_IGNORE_KEYWORDS = ['union', 'pivot', 'case', 'with'];

/**
 * A Wrapper around the error object raised from 'js-bigquery-parser'
 *
 * @param {Error} error
 * @returns {Object} Customized 'error' object
 */
function SyntaxError(error) {
  return { ...error.hash, message: error.message, error: true };
}

/**
 * TODO
 * @param {string} sqlQueryString
 * @param {Error} error
 * @returns {Object}
 */
function mysqlSyntaxChecker(sqlQueryString, error) {
  return { error: false };
}

/**
 * Currently, js-bigquery-parser doesn't have support for a few big query clauses.
 * If the query string contains any of these key words, we simply ignore any errors
 * that the parser may generate => in order to avoid false positive syntax errors.
 *
 * Eventually the parser will support those keywords but this works for now.
 *
 * For more details:
 * See: https://acho-team.atlassian.net/jira/software/projects/AT/boards/3?selectedIssue=AT-1074
 *
 * @param {string} sqlQueryString
 * @param {Error} error
 * @returns {SyntaxError | Object} a SyntaxError object or a non error object e.g.: { error: false }
 */
function bigQuerySyntaxChecker(sqlQueryString, error) {
  const ignoreSyntaxError = BIGQUERY_IGNORE_KEYWORDS.some((keyword) => sqlQueryString.toLowerCase().includes(keyword));
  if (ignoreSyntaxError) {
    return { error: false };
  }

  return SyntaxError(error);
}

/**
 * SqlParser is a wrapper around the js-bigquery-parser library that customizes the
 * parsing/syntax checking.
 *
 * @param {Object} config
 * @param {string} config.flavor the Sql Dialect/flavor to adhere to
 */
function SqlParser(config = {}) {
  this.config = { ...defaultConfig, ...config };

  /**
   * Attempts to parse and check syntax for a sql statement
   * in accordance with the SQL dialect.
   *
   * @param {string} sqlQueryString the sql statement
   * @returns {SyntaxError | Object} a SyntaxError object or a non error object e.g.: { error: false }
   */
  this.checkSyntax = (sqlQueryString) => {
    try {
      BigQueryParser.parse(sqlQueryString);
      return { error: false };
    } catch (error) {
      if (config.flavor === 'bigquery') {
        return bigQuerySyntaxChecker(sqlQueryString, error);
      }

      if (config.flavor === 'mysql') {
        return mysqlSyntaxChecker(sqlQueryString, error);
      }

      return SyntaxError(error);
    }
  };

  /**
   * A direct wrapper around the js-sql-parser's parse function
   *
   * @param {string} sqlQueryString the sql statement
   * @returns {any} response from js-sql-parser's parse function
   */
  this.parse = (sqlQueryString) => {
    // return parser.parse(sqlQueryString);
    return BigQueryParser.parse(sqlQueryString);
  };

  this.load = () => {
    //
  };
}

/**
 * You can install this wrapper as a plugin so that you can
 * access the parser via: this.$sqlparser.checkSyntax
 *
 * @param {Vue} Vue
 * @param {Object} options options for the wrapper
 */
function installSqlParser(Vue, options = {}) {
  Vue.sqlparser = new SqlParser(options);

  Object.defineProperties(Vue.prototype, {
    $sqlparser: {
      get() {
        return Vue.sqlparser;
      }
    }
  });
  Vue.sqlparser.load();
}

// You can install this plugin
export default installSqlParser;

// Or you can directly import the Parser via a named import
export { SqlParser, installSqlParser };
